export const InternationRoutes = [
{
    from: 'Lahore', 
    to: 'London',
    departCode: 'LHE',
    ArrivalCode: 'LHR',
    pathName: 'lahore-to-london',
    Heading: 'Discover Affordable Flights to London',
    backGroundImg: require('../../assets/city/banners/international pages/london.jpeg')
},
{
    from: 'Lahore', 
    to: 'Dubai',
    departCode: 'LHE',
    ArrivalCode: 'DXB',
    pathName: 'lahore-to-dubai',
    Heading: 'Book Lahore to Dubai Flights',
    backGroundImg: require('../../assets/city/banners/international pages/Dubai.png')
},
{
    from: 'Lahore', 
    to: 'Toronto',
    departCode: 'LHE',
    ArrivalCode: 'YTZ',
    pathName: 'lahore-to-toronto',
    Heading: 'Cheap Flights from Lahore to Toronto',
    backGroundImg: require('../../assets/city/banners/international pages/Toronto.png')
},
{
    from: 'Lahore', 
    to: 'NewYork',
    departCode: 'LHE',
    ArrivalCode: 'JFK',
    pathName: 'lahore-to-newyork',
    Heading: 'Find Affordable Flights to New York',
    backGroundImg: require('../../assets/city/banners/international pages/newYork.png')
},
{
    from: 'Lahore', 
    to: 'Boston',
    departCode: 'LHE',
    ArrivalCode: 'BOS',
    pathName: 'lahore-to-boston',
    // pathName: 'lahore-to-boston',
    Heading: 'Lahore to Boston Flight Deals',
    backGroundImg: require('../../assets/city/banners/international pages/boston.png')
},
{
    from: 'Lahore', 
    to: 'Perth',
    departCode: 'LHE',
    ArrivalCode: 'PER',
    pathName: 'lahore-to-perth',
    // pathName: 'lahore-to-perth',
    Heading: 'Explore Lahore to Perth Flights',
    backGroundImg: require('../../assets/city/banners/international pages/perth.png')
},
{
    from: 'Lahore', 
    to: 'Manchester',
    departCode: 'LHE',
    ArrivalCode: 'MAN',
    pathName: 'lahore-to-manchester',
    Heading: 'Affordable Flights to Manchester from Lahore',
    backGroundImg: require('../../assets/city/banners/international pages/Manchester.png')
},
{
    from: 'Lahore', 
    to: 'Melbourne',
    departCode: 'LHE',
    ArrivalCode: 'AVV',
    pathName: 'lahore-to-melbourne',
    Heading: 'Book Cheap Flights to Melbourne',
    backGroundImg: require('../../assets/city/banners/international pages/Malbourne.png')
},
{
    from: 'Lahore', 
    to: 'Atlanta',
    departCode: 'LHE',
    ArrivalCode: 'ATL',
    pathName: 'lahore-to-atlanta',
    Heading: 'Discover Lahore to Atlanta Deals',
    backGroundImg: require('../../assets/city/banners/international pages/Atlanta.png')
},
{
    from: 'Lahore', 
    to: 'Doha',
    departCode: 'LHE',
    ArrivalCode: 'DOH',
    pathName: 'lahore-to-doha',
    Heading: 'Lahore to Doha Flights Today',
    backGroundImg: require('../../assets/city/banners/international pages/Doha.png')
},
{
    from: 'Lahore', 
    to: 'Sydney',
    departCode: 'LHE',
    ArrivalCode: 'SYD',
    pathName: 'lahore-to-sydney',
    Heading: 'Find Lahore to Sydney Flights',
    backGroundImg: require('../../assets/city/banners/international pages/Sydney.png')
},
{
    from: 'Peshawar',
    to: 'London',
    departCode: 'PEW',
    ArrivalCode: 'LHR',
    pathName: 'peshawar-to-london',
    Heading: 'Discover Affordable Flights to London',
    backGroundImg: require('../../assets/city/banners/international pages/london.jpeg')
},
{
    from: 'Peshawar',
    to: 'Dubai',
    departCode: 'PEW',
    ArrivalCode: 'DXB',
    pathName: 'peshawar-to-dubai',
    Heading: 'Book Peshawar to Dubai Flights Today',
    backGroundImg: require('../../assets/city/banners/international pages/Dubai.png')
},
{
    from: 'Peshawar',
    to: 'Toronto',
    departCode: 'PEW',
    ArrivalCode: 'YTZ',
    pathName: 'peshawar-to-toronto',
    Heading: 'Cheap Flights from Peshawar to Toronto Available',
    backGroundImg: require('../../assets/city/banners/international pages/Toronto.png')
},
{
    from: 'Peshawar',
    to: 'NewYork',
    departCode: 'PEW',
    ArrivalCode: 'JFK',
    pathName: 'peshawar-to-newyork',
    Heading: 'Find Affordable Flights to New York',
    backGroundImg: require('../../assets/city/banners/international pages/newYork.png')
},
{
    from: 'Peshawar',
    to: 'Boston',
    departCode: 'PEW',
    ArrivalCode: 'BOS',
    pathName: 'peshawar-to-boston',
    Heading: 'Get Peshawar to Boston Flight Deals',
    backGroundImg: require('../../assets/city/banners/international pages/boston.png')
},
{
    from: 'Peshawar',
    to: 'Perth',
    departCode: 'PEW',
    ArrivalCode: 'PER',
    pathName: 'peshawar-to-perth',
    Heading: 'Explore Peshawar to Perth Flights Now',
    backGroundImg: require('../../assets/city/banners/international pages/perth.png')
},
{
    from: 'Peshawar',
    to: 'Manchester',
    departCode: 'PEW',
    ArrivalCode: 'MAN',
    pathName: 'peshawar-to-manchester',
    Heading: 'Affordable Flights to Manchester from Peshawar',
    backGroundImg: require('../../assets/city/banners/international pages/Manchester.png')
},
{
    from: 'Peshawar',
    to: 'Melbourne',
    departCode: 'PEW',
    ArrivalCode: 'AVV',
    pathName: 'peshawar-to-melbourne',
    Heading: 'Book Cheap Flights to Melbourne',
    backGroundImg: require('../../assets/city/banners/international pages/Malbourne.png')
},
{
    from: 'Peshawar',
    to: 'Atlanta',
    departCode: 'PEW',
    ArrivalCode: 'ATL',
    pathName: 'peshawar-to-atlanta',
    Heading: 'Discover Peshawar to Atlanta Flight Deals',
    backGroundImg: require('../../assets/city/banners/international pages/Atlanta.png')
},
{
    from: 'Peshawar',
    to: 'Doha',
    departCode: 'PEW',
    ArrivalCode: 'DOH',
    pathName: 'peshawar-to-doha',
    Heading: 'Peshawar to Doha Flights Available Today',
    backGroundImg: require('../../assets/city/banners/international pages/Doha.png')
},
{
    from: 'Peshawar',
    to: 'LosAngeles',
    departCode: 'PEW',
    ArrivalCode: 'CCD',
    pathName: 'peshawar-to-losangeles',
    Heading: 'Find Peshawar to Los Angeles Flights',
    backGroundImg: require('../../assets/city/banners/international pages/losAngels.png')
},
{
    from: 'Peshawar',
    to: 'Jeddah',
    departCode: 'PEW',
    ArrivalCode: 'JED',
    pathName: 'peshawar-to-jeddah',
    Heading: 'Cheap Peshawar to Jeddah Flights Today',
    backGroundImg: require('../../assets/city/banners/international pages/Jeddah.png')
},
{
    from: 'Peshawar',
    to: 'Istanbul',
    departCode: 'PEW',
    ArrivalCode: 'IST',
    pathName: 'peshawar-to-istanbul',
    Heading: 'Affordable Peshawar to Istanbul Travel Now',
    backGroundImg: require('../../assets/city/banners/international pages/istanbul.png')
},
{
    from: 'Faisalabad',
    to: 'LosAngeles',
    departCode: 'LYP',
    ArrivalCode: 'CCD',
    pathName: 'faisalabad-to-losangeles',
    Heading: 'Find Faisalabad to Los Angeles Flights',
    backGroundImg: require('../../assets/city/banners/international pages/losAngels.png')
},
{
    from: 'Faisalabad',
    to: 'Jeddah',
    departCode: 'LYP',
    ArrivalCode: 'JED',
    pathName: 'faisalabad-to-jeddah',
    Heading: 'Cheap Faisalabad to Jeddah Flights Today',
    backGroundImg: require('../../assets/city/banners/international pages/Jeddah.png')
},
{
    from: 'Faisalabad',
    to: 'Istanbul',
    departCode: 'LYP',
    ArrivalCode: 'IST',
    pathName: 'faisalabad-to-istanbul',
    Heading: 'Affordable Faisalabad to Istanbul Travel Now',
    backGroundImg: require('../../assets/city/banners/international pages/istanbul.png')
},{
    from: 'Karachi',
    to: 'London',
    departCode: 'KHI',
    ArrivalCode: 'LHR',
    pathName: 'karachi-to-london',
    Heading: 'Discover Affordable Flights to London',
    backGroundImg: require('../../assets/city/banners/international pages/London.png')
},
{
    from: 'Karachi',
    to: 'Dubai',
    departCode: 'KHI',
    ArrivalCode: 'DXB',
    pathName: 'karachi-to-dubai',
    Heading: 'Book Karachi to Dubai Flights Today',
    backGroundImg: require('../../assets/city/banners/international pages/Dubai.png')
},
{
    from: 'Karachi',
    to: 'Toronto',
    departCode: 'KHI',
    ArrivalCode: 'YTZ',
    pathName: 'karachi-to-toronto',
    Heading: 'Cheap Flights from Karachi to Toronto',
    backGroundImg: require('../../assets/city/banners/international pages/Toronto.png')
},
{
    from: 'Karachi',
    to: 'NewYork',
    departCode: 'KHI',
    ArrivalCode: 'JFK',
    pathName: 'karachi-to-newyork',
    Heading: 'Find Affordable Flights to New York',
    backGroundImg: require('../../assets/city/banners/international pages/newYork.png')
},
{
    from: 'Karachi',
    to: 'Boston',
    departCode: 'KHI',
    ArrivalCode: 'BOS',
    pathName: 'karachi-to-boston',
    Heading: 'Get Karachi to Boston Flight Deals',
    backGroundImg: require('../../assets/city/banners/international pages/boston.png')
},
{
    from: 'Karachi',
    to: 'Perth',
    departCode: 'KHI',
    ArrivalCode: 'PER',
    pathName: 'karachi-to-perth',
    Heading: 'Explore Karachi to Perth Flights Now',
    backGroundImg: require('../../assets/city/banners/international pages/perth.png')
},
{
    from: 'Karachi',
    to: 'Manchester',
    departCode: 'KHI',
    ArrivalCode: 'MAN',
    pathName: 'karachi-to-manchester',
    Heading: 'Affordable Flights to Manchester from Karachi',
    backGroundImg: require('../../assets/city/banners/international pages/Manchester.png')
},
{
    from: 'Karachi',
    to: 'Melbourne',
    departCode: 'KHI',
    ArrivalCode: 'AVV',
    pathName: 'karachi-to-melbourne',
    Heading: 'Book Cheap Flights to Melbourne',
    backGroundImg: require('../../assets/city/banners/international pages/Malbourne.png')
},
{
    from: 'Karachi',
    to: 'Atlanta',
    departCode: 'KHI',
    ArrivalCode: 'ATL',
    pathName: 'karachi-to-atlanta',
    Heading: 'Discover Karachi to Atlanta Flight Deals',
    backGroundImg: require('../../assets/city/banners/international pages/Atlanta.png')
},
{
    from: 'Karachi',
    to: 'Doha',
    departCode: 'KHI',
    ArrivalCode: 'DOH',
    pathName: 'karachi-to-doha',
    Heading: 'Karachi to Doha Flights Available Today',
    backGroundImg: require('../../assets/city/banners/international pages/Doha.png')
},
{
    from: 'Karachi',
    to: 'LosAngeles',
    departCode: 'KHI',
    ArrivalCode: 'CCD',
    pathName: 'karachi-to-losangeles',
    Heading: 'Find Karachi to Los Angeles Flights',
    backGroundImg: require('../../assets/city/banners/international pages/losAngels.png')
},
{
    from: 'Karachi',
    to: 'Jeddah',
    departCode: 'KHI',
    ArrivalCode: 'JED',
    pathName: 'karachi-to-jeddah',
    Heading: 'Cheap Karachi to Jeddah Flights Today',
    backGroundImg: require('../../assets/city/banners/international pages/Jeddah.png')
},
{
    from: 'Karachi',
    to: 'Istanbul',
    departCode: 'KHI',
    ArrivalCode: 'IST',
    pathName: 'karachi-to-istanbul',
    Heading: 'Affordable Karachi to Istanbul Travel Now',
    backGroundImg: require('../../assets/city/banners/international pages/istanbul.png')
},
{
    from: 'Quetta',
    to: 'London',
    departCode: 'UET',
    ArrivalCode: 'LHR',
    pathName: 'quetta-to-london',
    Heading: 'well come to london',
    backGroundImg: require('../../assets/city/banners/international pages/London.png')
},
{
    from: 'Quetta',
    to: 'Dubai',
    departCode: 'UET',
    ArrivalCode: 'DXB',
    pathName: 'quetta-to-dubai',
    Heading: 'Welcome to Dubai',
    backGroundImg: require('../../assets/city/banners/international pages/Dubai.png')
},
{
    from: 'Quetta',
    to: 'Toronto',
    departCode: 'UET',
    ArrivalCode: 'YTZ',
    pathName: 'quetta-to-toronto',
    Heading: 'Welcome to Toronto',
    backGroundImg: require('../../assets/city/banners/international pages/Toronto.png')
},
{
    from: 'Quetta',
    to: 'NewYork',
    departCode: 'UET',
    ArrivalCode: 'JFK',
    pathName: 'quetta-to-newyork',
    Heading: 'Welcome to New York',
    backGroundImg: require('../../assets/city/banners/international pages/newYork.png')
},
{
    from: 'Quetta',
    to: 'Boston',
    departCode: 'UET',
    ArrivalCode: 'BOS',
    pathName: 'quetta-to-boston',
    Heading: 'Welcome to Boston',
    backGroundImg: require('../../assets/city/banners/international pages/boston.png')
},
{
    from: 'Quetta',
    to: 'Perth',
    departCode: 'UET',
    ArrivalCode: 'PER',
    pathName: 'quetta-to-perth',
    Heading: 'Welcome to Perth',
    backGroundImg: require('../../assets/city/banners/international pages/perth.png')
},
{
    from: 'Quetta',
    to: 'Manchester',
    departCode: 'UET',
    ArrivalCode: 'MAN',
    pathName: 'quetta-to-manchester',
    Heading: 'Welcome to Manchester',
    backGroundImg: require('../../assets/city/banners/international pages/Manchester.png')
},
{
    from: 'Quetta',
    to: 'Melbourne',
    departCode: 'UET',
    ArrivalCode: 'AVV',
    pathName: 'quetta-to-melbourne',
    Heading: 'Welcome to Melbourne',
    backGroundImg: require('../../assets/city/banners/international pages/Malbourne.png')
},
{
    from: 'Quetta',
    to: 'Atlanta',
    departCode: 'UET',
    ArrivalCode: 'ATL',
    pathName: 'quetta-to-atlanta',
    Heading: 'Welcome to Atlanta',
    backGroundImg: require('../../assets/city/banners/international pages/Atlanta.png')
},
{
    from: 'Quetta',
    to: 'Doha',
    departCode: 'UET',
    ArrivalCode: 'DOH',
    pathName: 'quetta-to-doha',
    Heading: 'Welcome to Doha',
    backGroundImg: require('../../assets/city/banners/international pages/Doha.png')
},
{
    from: 'Quetta',
    to: 'LosAngeles',
    departCode: 'UET',
    ArrivalCode: 'LAX',
    pathName: 'quetta-to-losangeles',
    Heading: 'Welcome to Los Angeles',
    backGroundImg: require('../../assets/city/banners/international pages/losAngels.png')
},
{
    from: 'Quetta',
    to: 'Jeddah',
    departCode: 'UET',
    ArrivalCode: 'JED',
    pathName: 'quetta-to-jeddah',
    Heading: 'Welcome to Jeddah',
    backGroundImg: require('../../assets/city/banners/international pages/Jeddah.png')
},
{
    from: 'Quetta',
    to: 'Istanbul',
    departCode: 'UET',
    ArrivalCode: 'IST',
    pathName: 'quetta-to-istanbul',
    Heading: 'Welcome to Istanbul',
    backGroundImg: require('../../assets/city/banners/international pages/istanbul.png')
},{
    from: 'Islamabad',
    to: 'London',
    departCode: 'ISB',
    ArrivalCode: 'LHR',
    pathName: 'islamabad-to-london',
    Heading: 'Welcome to London',
    backGroundImg: require('../../assets/city/banners/international pages/London.png')
},
{
    from: 'Islamabad',
    to: 'Dubai',
    departCode: 'ISB',
    ArrivalCode: 'DXB',
    pathName: 'islamabad-to-dubai',
    Heading: 'Welcome to Dubai',
    backGroundImg: require('../../assets/city/banners/international pages/Dubai.png')
},
{
    from: 'Islamabad',
    to: 'Toronto',
    departCode: 'ISB',
    ArrivalCode: 'YTZ',
    pathName: 'islamabad-to-toronto',
    Heading: 'Welcome to Toronto',
    backGroundImg: require('../../assets/city/banners/international pages/Toronto.png')
},
{
    from: 'Islamabad',
    to: 'NewYork',
    departCode: 'ISB',
    ArrivalCode: 'JFK',
    pathName: 'islamabad-to-newyork',
    Heading: 'Welcome to New York',
    backGroundImg: require('../../assets/city/banners/international pages/newYork.png')
},
{
    from: 'Islamabad',
    to: 'Boston',
    departCode: 'ISB',
    ArrivalCode: 'BOS',
    pathName: 'islamabad-to-boston',
    Heading: 'Welcome to Boston',
    backGroundImg: require('../../assets/city/banners/international pages/boston.png')
},
{
    from: 'Islamabad',
    to: 'Perth',
    departCode: 'ISB',
    ArrivalCode: 'PER',
    pathName: 'islamabad-to-perth',
    Heading: 'Welcome to Perth',
    backGroundImg: require('../../assets/city/banners/international pages/perth.png')
},
{
    from: 'Islamabad',
    to: 'Manchester',
    departCode: 'ISB',
    ArrivalCode: 'MAN',
    pathName: 'islamabad-to-manchester',
    Heading: 'Welcome to Manchester',
    backGroundImg: require('../../assets/city/banners/international pages/Manchester.png')
},
{
    from: 'Islamabad',
    to: 'Melbourne',
    departCode: 'ISB',
    ArrivalCode: 'AVV',
    pathName: 'islamabad-to-melbourne',
    Heading: 'Welcome to Melbourne',
    backGroundImg: require('../../assets/city/banners/international pages/Malbourne.png')
},
{
    from: 'Islamabad',
    to: 'Atlanta',
    departCode: 'ISB',
    ArrivalCode: 'ATL',
    pathName: 'islamabad-to-atlanta',
    Heading: 'Welcome to Atlanta',
    backGroundImg: require('../../assets/city/banners/international pages/Atlanta.png')
},
{
    from: 'Islamabad',
    to: 'Doha',
    departCode: 'ISB',
    ArrivalCode: 'DOH',
    pathName: 'islamabad-to-doha',
    Heading: 'Welcome to Doha',
    backGroundImg: require('../../assets/city/banners/international pages/Doha.png')
},
{
    from: 'Islamabad',
    to: 'LosAngeles',
    departCode: 'ISB',
    ArrivalCode: 'LAX',
    pathName: 'islamabad-to-losangeles',
    Heading: 'Welcome to Los Angeles',
    backGroundImg: require('../../assets/city/banners/international pages/losAngels.png')
},
{
    from: 'Islamabad',
    to: 'Jeddah',
    departCode: 'ISB',
    ArrivalCode: 'JED',
    pathName: 'islamabad-to-jeddah',
    Heading: 'Welcome to Jeddah',
    backGroundImg: require('../../assets/city/banners/international pages/Jeddah.png')
},
{
    from: 'Islamabad',
    to: 'Istanbul',
    departCode: 'ISB',
    ArrivalCode: 'IST',
    pathName: 'islamabad-to-istanbul',
    Heading: 'Welcome to Istanbul',
    backGroundImg: require('../../assets/city/banners/international pages/istanbul.png')
},
{
    from: 'Multan',
    to: 'London',
    departCode: 'MUX',
    ArrivalCode: 'LHR',
    pathName: 'multan-to-london',
    Heading: 'Welcome to London',
    backGroundImg: require('../../assets/city/banners/international pages/London.png')
},
{
    from: 'Multan',
    to: 'Dubai',
    departCode: 'MUX',
    ArrivalCode: 'DXB',
    pathName: 'multan-to-dubai',
    Heading: 'Welcome to Dubai',
    backGroundImg: require('../../assets/city/banners/international pages/Dubai.png')
},
{
    from: 'Multan',
    to: 'Toronto',
    departCode: 'MUX',
    ArrivalCode: 'YTZ',
    pathName: 'multan-to-toronto',
    Heading: 'Welcome to Toronto',
    backGroundImg: require('../../assets/city/banners/international pages/Toronto.png')
},
{
    from: 'Multan',
    to: 'NewYork',
    departCode: 'MUX',
    ArrivalCode: 'JFK',
    pathName: 'multan-to-newyork',
    Heading: 'Welcome to New York',
    backGroundImg: require('../../assets/city/banners/international pages/newYork.png')
},
{
    from: 'Multan',
    to: 'Boston',
    departCode: 'MUX',
    ArrivalCode: 'BOS',
    pathName: 'multan-to-boston',
    Heading: 'Welcome to Boston',
    backGroundImg: require('../../assets/city/banners/international pages/boston.png')
},
{
    from: 'Multan',
    to: 'Perth',
    departCode: 'MUX',
    ArrivalCode: 'PER',
    pathName: 'multan-to-perth',
    Heading: 'Welcome to Perth',
    backGroundImg: require('../../assets/city/banners/international pages/perth.png')
},
{
    from: 'Multan',
    to: 'Manchester',
    departCode: 'MUX',
    ArrivalCode: 'MAN',
    pathName: 'multan-to-manchester',
    Heading: 'Welcome to Manchester',
    backGroundImg: require('../../assets/city/banners/international pages/Manchester.png')
},
{
    from: 'Multan',
    to: 'Melbourne',
    departCode: 'MUX',
    ArrivalCode: 'AVV',
    pathName: 'multan-to-melbourne',
    Heading: 'Welcome to Melbourne',
    backGroundImg: require('../../assets/city/banners/international pages/Malbourne.png')
},
{
    from: 'Multan',
    to: 'Atlanta',
    departCode: 'MUX',
    ArrivalCode: 'ATL',
    pathName: 'multan-to-atlanta',
    Heading: 'Welcome to Atlanta',
    backGroundImg: require('../../assets/city/banners/international pages/Atlanta.png')
},
{
    from: 'Multan',
    to: 'Doha',
    departCode: 'MUX',
    ArrivalCode: 'DOH',
    pathName: 'multan-to-doha',
    Heading: 'Welcome to Doha',
    backGroundImg: require('../../assets/city/banners/international pages/Doha.png')
},
{
    from: 'Multan',
    to: 'LosAngeles',
    departCode: 'MUX',
    ArrivalCode: 'LAX',
    pathName: 'multan-to-losangeles',
    Heading: 'Welcome to Los Angeles',
    backGroundImg: require('../../assets/city/banners/international pages/losAngels.png')
},
{
    from: 'Multan',
    to: 'Jeddah',
    departCode: 'MUX',
    ArrivalCode: 'JED',
    pathName: 'multan-to-jeddah',
    Heading: 'Welcome to Jeddah',
    backGroundImg: require('../../assets/city/banners/international pages/Jeddah.png')
},
{
    from: 'Multan',
    to: 'Istanbul',
    departCode: 'MUX',
    ArrivalCode: 'IST',
    pathName: 'multan-to-istanbul',
    Heading: 'Welcome to Istanbul',
    backGroundImg: require('../../assets/city/banners/international pages/istanbul.png')
}
    ];